import React, {useEffect, useState} from 'react';
import {useNavigation} from '@react-navigation/native';
import {RNS3} from 'react-native-aws3';
import ImagePicker from 'react-native-image-crop-picker';
import {check, request, PERMISSIONS, RESULTS} from 'react-native-permissions';

import {v4 as uuid} from 'uuid';

import {Header} from '../../../components/Interface/Headers/Header';
import {Titles} from '../../../components/Interface/Typographies/Titles';

import {useAuth} from '../../../context/auth';

import {
  Container,
  Content,
  UserWrapper,
  UserInfoWrapper,
  UserInfo,
  UserGreeting,
  UserName,
  PhotoContainer,
  Photo,
  Infos,
  Item,
  Button,
  ItemContainer,
  Label,
  ItemName,
  DeleteAccountButtonContainer,
  DeleteAccountButton,
  DeleteAccountButtonText,
  IconContainer,
  Icon,
} from './styles';

import {Alert, Linking, Platform} from 'react-native';
import {Loading} from '../../../components/Interface/Loadings/Loading';

const options = {
  keyPrefix: 'baratao/users',
  bucket: 'barataocombustiveis',
  region: 'sa-east-1',
  accessKey: 'AKIAVSUC44DEGXQQPC5M',
  secretKey: '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',
  successActionStatus: 201,
};

export function Account() {
  const navigation = useNavigation();
  const {user, updateAvatar, defaultAvatar} = useAuth();

  const {name, email} = user;

  const [avatar, setAvatar] = useState(user.avatarUrl);
  const [isLoading, setIsLoading] = useState(false);

  async function handleProfileUpdate(uri: string, type: string, name: string) {
    setIsLoading(true);
    try {
      const file = {
        uri: uri,
        name: name,
        type: type,
      };

      await RNS3.put(file, options)
        .then(async (response: any) => {
          if (response.status !== 201) {
            Alert.alert('Não foi possível atualizar o perfil');
          } else {
            const {location} = response.body.postResponse;

            const isPhoneVerified = !!user.phone_verified;

            await updateAvatar({
              id: user.id,
              user_id: user.user_id,
              email: user.email,
              name: user.name,
              cpf: user.cpf,
              phone: user.phone,
              avatarUrl: location,
              token: user.token,
              codCompartilhar: user.codCompartilhar,
              phone_verified: isPhoneVerified,
            });
            setAvatar(location);

            setIsLoading(false);
          }
        })
        .catch(() => {
          Alert.alert('Não foi possível atualizar o perfil');
          setIsLoading(false);
        });
    } catch (error) {
      Alert.alert('Não foi possível atualizar o perfil');
      setIsLoading(false);
    }
  }

  async function handleSelectAvatar() {
    // On Android 13+, react-native-image-crop-picker uses the Photo Picker API
    // which doesn't require READ_MEDIA_IMAGES permission.
    // On iOS, we still need to check PHOTO_LIBRARY permission.
    if (Platform.OS === 'ios') {
      try {
        const permission = PERMISSIONS.IOS.PHOTO_LIBRARY;
        const result = await check(permission);

        if (result === RESULTS.UNAVAILABLE) {
          Alert.alert(
            'Permissão indisponível',
            'O acesso à galeria não está disponível neste dispositivo.',
          );
          return;
        }

        if (result === RESULTS.GRANTED || result === RESULTS.LIMITED) {
          openImagePicker();
        } else if (result === RESULTS.DENIED || result === RESULTS.BLOCKED) {
          const requestResult = await request(permission);

          if (requestResult === RESULTS.GRANTED || requestResult === RESULTS.LIMITED) {
            openImagePicker();
          } else {
            showSettingsAlert();
          }
        }
      } catch (error) {
        console.error('Erro ao verificar permissões:', error);
        Alert.alert(
          'Erro',
          'Ocorreu um erro ao verificar as permissões. Tente novamente mais tarde.',
        );
      }
    } else {
      // Android: Photo Picker doesn't require permissions
      openImagePicker();
    }
  }

  function showSettingsAlert() {
    Alert.alert(
      'Permissão necessária',
      'O aplicativo precisa de permissão para acessar sua galeria.',
      [
        {text: 'Cancelar', style: 'cancel'},
        {
          text: 'Abrir configurações',
          onPress: () => Linking.openSettings(),
        },
      ],
    );
  }

  async function openImagePicker() {
    await ImagePicker.openPicker({
      mediaType: 'photo',
      width: 512,
      height: 512,
      showCropFrame: true,
      cropperCircleOverlay: true,
      forceJpg: true,
      compressImageQuality: 1,
      cropping: true,
    })
      .then(image => {
        handleProfileUpdate(image.path, image.mime, uuid());
      })
      .catch(error => {
        console.log(error);
      });
  }

  const [userAvatar, setUserAvatar] = useState(user.avatarUrl);

  useEffect(() => {
      setUserAvatar(user.avatarUrl);
    }, [user.avatarUrl]);

  return (
    <Container>
      {isLoading && <Loading />}
      <Header icon="chevron-left" />
      <Content>
        <Titles title="Perfil" />

        <UserWrapper>
          <UserInfoWrapper>
            <PhotoContainer activeOpacity={0.7} onPress={handleSelectAvatar}>
              <IconContainer>
                <Icon name="camera" />
              </IconContainer>
              <Photo source={{uri: userAvatar}} onError={() => setUserAvatar(defaultAvatar)}/>
            </PhotoContainer>
            <UserInfo>
              <UserName>{user.name}</UserName>
              <UserGreeting>
                CPF: XXX.XXX.XXX-{user.cpf.length > 2 ? user.cpf.substring(9, 11) : user.cpf}
              </UserGreeting>
            </UserInfo>
          </UserInfoWrapper>
        </UserWrapper>

        <Infos>
          <Item>
            <Button disabled={true}>
              <ItemContainer>
                <Label>Nome</Label>
                <ItemName capitalize>{name}</ItemName>
              </ItemContainer>
            </Button>
          </Item>
          <Item>
            <Button disabled={true}>
              <ItemContainer>
                <Label>Telefone</Label>
                <ItemName>{user.phone}</ItemName>
              </ItemContainer>
            </Button>
          </Item>
          <Item>
            <Button disabled={true}>
              <ItemContainer>
                <Label>Email</Label>
                <ItemName>{email}</ItemName>
              </ItemContainer>
            </Button>
          </Item>
          <Item>
            <Button disabled={true}>
              <ItemContainer>
                <Label>CPF</Label>
                <ItemName>XXX.XXX.XXX-{user.cpf.length > 2 ? user.cpf.substring(9, 11) : user.cpf}</ItemName>
              </ItemContainer>
            </Button>
          </Item>
        </Infos>
       {
        Platform.OS !== 'web' &&  <DeleteAccountButtonContainer>
          <DeleteAccountButton
            onPress={() => navigation.navigate('DeleteAccount')}
            activeOpacity={1}>
            <DeleteAccountButtonText>
              Encerrar minha conta
            </DeleteAccountButtonText>
          </DeleteAccountButton>
        </DeleteAccountButtonContainer>
       }
      </Content>
    </Container>
  );
}
